///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component } from '@angular/core';
import { AbstractDialogManager } from '../../../dialog-manager/abstract-dialog-manager';
import { CustomerDTO } from '../../../generated/shared-types.model';
import { GtthCustomerService } from '../../../services/customer/customer.service';
import { Observable } from 'rxjs';
import { BlockCustomerDialogComponent } from './block-customer-dialog.component';

@Component({
    selector: 'winde-block-customer-dialog-wrapper-component',
    template: '',
    standalone: false
})
export class BlockCustomerDialogWrapperComponent extends AbstractDialogManager<CustomerDTO, BlockCustomerDialogComponent> {
    constructor(private readonly customerService: GtthCustomerService) {
        super(BlockCustomerDialogComponent);
        this.openDialog();
    }

    preparingBaseConfig(): void {
        this.baseConfig.width = '800px';
        this.baseConfig.position = { top: '30px' };
        this.baseConfig.data.id = +this.activatedRoute.snapshot.paramMap.get('id') || null;
    }

    override findById(id: number): Observable<CustomerDTO> {
        return this.customerService.find(id);
    }
}
